app.modules.rubricTags = ((self = {}) => {
  const _componentEl = document.querySelector('.js-rubric-tags');
  const _sliderEl = document.querySelector('.js-rubric-tags__slider');
  const _leftButtonEl = _componentEl.querySelector(
    '.js-rubric-tags__button_left'
  );
  const _rightButtonEl = _componentEl.querySelector(
    '.js-rubric-tags__button_right'
  );

  const _componentWidth = _componentEl.clientWidth;
  const _slideWidth = _sliderEl.scrollWidth;
  const _minShift = 0;
  const _maxShift = _slideWidth - _componentWidth;

  function _getSlideShift() {
    return _sliderEl.style.left
      ? Number(_sliderEl.style.left.match(/\d+/)[0])
      : 0;
  }

  function _handleLeftButtonClick(event) {
    event.preventDefault();
    _rightButtonEl.classList.remove('rubric-tags__button_disable');

    let newShift = _getSlideShift() - _componentWidth;

    if (newShift <= _minShift) {
      newShift = 0;
      _leftButtonEl.classList.add('rubric-tags__button_disable');
    }

    _sliderEl.style.left = `-${newShift}px`;
  }

  function _handleRightButtonClick(event) {
    event.preventDefault();
    _leftButtonEl.classList.remove('rubric-tags__button_disable');

    let newShift = _getSlideShift() + _componentWidth;

    if (newShift >= _maxShift) {
      newShift = _maxShift;
      _rightButtonEl.classList.add('rubric-tags__button_disable');
    }

    _sliderEl.style.left = `-${newShift}px`;
  }

  function _setListeners() {
    _leftButtonEl.addEventListener('click', _handleLeftButtonClick);
    _rightButtonEl.addEventListener('click', _handleRightButtonClick);
  }

  function _init() {
    if (_componentWidth > _slideWidth) {
      _rightButtonEl.classList.add('rubric-tags__button_disable');
      return;
    }

    _setListeners();
  }

  self.load = _init;
  return self;
})(app.modules.rubricTags);
